import { FC, useEffect } from "react";
import { Supplier } from "../../../../types/slices/supplierType";
import { Divider, Drawer, Grid, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTable from "../../../../components/common/CustomTable/CustomTable";
import { useAccountReceivableStore } from "../../../../hooks/useAccountReceivableStore";
import { ApiStatus } from "../../../../types/api/status";
import { moneyCL } from "../../../../toolbox/helpers/money-helpers";
import { formatDate, formatDateTime } from "../../../../toolbox/helpers/formatDateHelper";


interface Props {
    open: boolean
    onClose: () => void
    customer: Supplier
}

interface onList {
    page?: number
    perPage?: number
    idsupplier?: number
    search?: string
}

const columns = [
    { type: 'text', field: 'folio', label: 'N° Folio', align: 'center' },
    { type: 'text', field: 'way_to_pay', label: 'Forma de pago', align: 'center' },
    { type: 'text', field: 'total', label: 'Total factura', align: 'center', format: (row) => moneyCL(row.total) },
    { type: 'text', field: 'ticket_date', label: 'Emisión', align: 'center', format: (row) => formatDateTime(row.ticket_date) },
    { type: 'text', field: 'deadline', label: 'Vencimiento', align: 'center', format: (row) => formatDate(row.deadline) },
    { type: 'text', field: 'payment_date', label: 'Fecha de pago', align: 'center', format: (row) => formatDateTime(row.payment_date) },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
]

export const AccountPaidDrawer: FC<Props> = (props) => {
    const { open, onClose, customer } = props

    const { status: statusAccounts, accounts, getAccountsReceivable } = useAccountReceivableStore()

    useEffect(() => {
        getAccountsReceivable({
            paid: 1
        })
    }, [])

    const onSearch = () => { }
    const onDetails = (rowSelected) => {
        if (!rowSelected?.url_document) return

        window.open(process.env.REACT_APP_ROOT_URL + rowSelected.url_document, '_blank')
    }

    return (
        <Drawer
            open={open}
            onClose={onClose}
            anchor="right"
        >
            <Grid container sx={{ width: 950, padding: 2 }} spacing={2}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        Cuentas pagadas
                    </Typography>
                </Grid>
                <Grid item xs={12} mb={1}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <CustomTable
                        title={customer?.name_rz}
                        columns={columns}
                        rows={accounts || []}
                        onRowClick={() => { }}
                        hasOptions
                        onDetails={onDetails}
                        onSearch={onSearch}
                        loading={statusAccounts === ApiStatus.FETCHING}
                        dense
                        withRowsColors
                    />
                </Grid>
            </Grid>
        </Drawer>
    )
}